<template>
	<div id="test-index">
		<div class="row g-3 mb-3">
			<div>
				<div
					class="card-header audience-chart-header p-0 scrollbar-overlay"
				>
					<ul
						class="nav nav-tabs border-0 chart-tab flex-nowrap"
						id="audience-chart-tab"
						role="tablist"
					>
						<li
							v-for="(item, index) in menu"
							:key="'menu-' + index"
							class="nav-item bg-light me-2"
						>
							<router-link
								class="nav-link mb-0 text-500 fs-0"
								:class="[
									item.routeName == current ? 'active' : '',
								]"
								:to="item.url"
								id="users-tab"
								data-bs-toggle="tab"
								role="tab"
								aria-controls="users"
								aria-selected="true"
							>
								<div class="audience-tab-item p-2 px-3">
									<p class="ff-ch fw-medium text-center">{{
										item.name
									}}</p>
								</div>
							</router-link>
						</li>
					</ul>
				</div>

				<div class="card overflow-hidden mb-3 mt-n1">
					<div
						class="card-body padding-adjust"
						v-for="(item, index) in userData.qa"
						:key="item.name"
					>
						<div class="tab-content col-11 m-auto">
							<div
								class="card-test-group card bg-blue-bg card overflow-hidden"
							>
								<div class="card-body">
									<div class="row">
										<div class="col-7">
											<h5
												class="c-main-blue py-2 lh-sm ff-ch fw-bold"
												>{{ item.name }}</h5
											>
										</div>
										<div class="col-5 text-end">
											<div
												class="answer-progress px-3 py-2 d-inline-block text-center lh-sm"
											>
												<h6 class="c-main-blue ff-ch"
													>尚有
													{{ item.remain }}
													題未作答</h6
												>
											</div>
										</div>
									</div>
									<div class="row mt-3">
										<div class="col">
											<p class="lh-base ff-ch"
												>點擊觀看 HFMSE
												評估影片，請依各題項說明 (共{{
													item.qa.length
												}}項)，給予評分。</p
											>
										</div>
									</div>
									<div class="row">
										<div class="col">
											<div
												class="btn btn-primary mt-4 px-5"
												@click="showNotification(index)"
											>
												<div
													class="c-white ff-ch fw-light fs-0"
												>
													<i
														data-feather="edit-2"
														width="11"
														stroke-width="2"
													></i
													>測驗
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			class="modal"
			id="staticBackdrop"
			data-bs-keyboard="false"
			data-bs-backdrop="static"
			tabindex="-1"
			aria-labelledby="staticBackdropLabel"
			:aria-hidden="!beforeTest"
			:aria-modal="beforeTest"
			:style="{
				display: beforeTest ? 'block' : 'none',
				opacity: beforeTest ? 1 : 0,
			}"
		>
			<div
				class="modal-dialog modal-dialog-centered h-50 justify-content-center"
				role="dialog"
			>
				<div class="modal-content position-relative border-0">
					<div
						class="position-absolute top-0 end-0 mt-2 me-2 z-index-1"
					>
						<button
							class="btn-close btn btn-sm btn-circle d-flex flex-center transition-base"
							@click="showNotification(0)"
						></button>
					</div>
					<div
						class="modal-body d-flex flex-column justify-content-evenly align-items-center"
					>
						<div class="c-main-blue ff-ch fw-bold fs-1">
							評測注意事項
						</div>
						<div class="ff-ch lh-lg fs-0">
							1. 影片播放後，無法暫停 / 回放<br />
							2. 每題影片限觀看 3 次<br />
							3. 題目作答後，無法更改
						</div>
						<div
							class="btn btn-primary c-white ff-ch fw-light fs-0 py-2 px-5"
							@click="enterGroup"
						>
							<i
								data-feather="edit-2"
								width="11"
								stroke-width="2"
							></i>
							開始作答
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	data() {
		return {
			beforeTest: false,
			group: 0,
		};
	},

	computed: {
		...mapGetters({ menu: "menu", userData: "getUserData" }),
		current() {
			return this.$route.name;
		},
	},

	methods: {
		showNotification(val) {
			this.beforeTest = !this.beforeTest;
			this.group = val;
		},
		enterGroup() {
			this.beforeTest = !this.beforeTest;
			this.$router.push(`/test/${this.group + 1}`);
		},
	},

	created() {
		this.$store.commit("navLeftSwitch", "show");
	},

	mounted() {
		feather.replace();
	},
};
</script>

<style lang="scss" scoped>
.answer-progress {
	width: auto !important;
	border: 1px solid #759bcb;
	border-radius: 30px;
}

.card-test-group {
	background-repeat: no-repeat;
	background-size: auto 150%;
	background-position: right bottom;
	background-image: url("./../../assets/wireframe.svg");
}

.padding-adjust {
	padding: 0 1.25rem;
	padding-top: 2.5rem;
}

.padding-adjust:last-child {
	padding-bottom: 2.5rem;
}

.card-header.audience-chart-header.p-0.scrollbar-overlay {
	background-color: var(--falcon-body-bg);
}

.modal {
	background-color: rgba(#111, 0.7);
	transition: opacity 0.2s 0.5s linear;
}

.modal-content {
	height: 40%;
	max-width: 85vw;
}

@media screen and (max-width: 768px) {
	#test-index {
		.row.g-3.mb-3 {
			.card-header {
				ul {
					.nav-item.bg-light.me-2 {
						width: 50%;
					}
					.nav-item.bg-light.me-2:last-child {
						margin-right: 0 !important;
					}
				}
			}
		}
	}
}
</style>
